/**
 * **************************************************************************
 * Toastr service file
 * Display toast messages wherever invoked
 * Usually used to display success or failure messges to user
 * 
 * Defines various method that can be used to display the toast messages
 * Hides after 3000ms
 * Is configured in app.module.ts
 * **************************************************************************
 */

import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})

export class ToastService {

  /**
   * Constructor
   * @param ts 
   */
  constructor(public ts: ToastrService) { }


  /**
   * Convert a string to sentence case.
   * @param str The string to convert to sentence case.
   * @returns The sentence-cased string.
   */
  private toSentenceCase(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  /**
   * Show success toastr
   * @param title : Title of the toastr
   * @param msg : Message to be displayed
   */
  public showSuccess(title: string, msg: string): void {
    this.ts.success(this.toSentenceCase(msg), this.toSentenceCase(title));
  }

  /**
   * Show info toastr
   * @param title : Title of the toastr
   * @param msg : Message to be displayed
   */
  public showInfo(title: string, msg: string): void {
    this.ts.info(this.toSentenceCase(msg), this.toSentenceCase(title));
  }

  /**
   * Show warning toastr
   * @param title : Title of the toastr
   * @param msg : Message to be displayed
   */
  public showWarning(title: string, msg: string): void {
    this.ts.warning(this.toSentenceCase(msg), this.toSentenceCase(title));
  }

  /**
   * Show error toastr
   * @param title : Title of the toastr
   * @param msg : Message to be displayed
   */
  public showError(title: string, msg: string): void {
    this.ts.error(this.toSentenceCase(msg), this.toSentenceCase(title));
  }

  /** close the toaster if any open */
  public closeToast() {
    this.ts.clear();
  }
}
